import axiosInstance from './axiosInstance';

// Free-text area/postcode/address -> { lat, lng } (centers the map).
export const geocodeAddress = (q) =>
    axiosInstance.get(`/InstallsMap/Geocode?q=${encodeURIComponent(q)}`);

// Installed (Active) customers within radiusKm of a point.
export const getNearbyInstalls = (lat, lng, radiusKm = 10) =>
    axiosInstance.get(`/InstallsMap/Nearby?lat=${lat}&lng=${lng}&radiusKm=${radiusKm}`);
